import { CountUp } from "https://cdn.jsdelivr.net/npm/countup.js@2.0.8/dist/countUp.min.js";

const options = {
  startVal: 0.0,
  decimalPlaces: 2,
  useGrouping: false,
  separator: "",
};

const statsArray = {
  "statystyki-ogolne": {
    "completed-projects": 500,
    ROAS: 22.0,
    "click-growth": 80.0,
    "increase-views": 208.66,
    "top-100": 11177.0,
  },

  elektronika: {
    "completed-projects": 105,
    ROAS: 22.5,
    "click-growth": 80.3,
    "increase-views": 209.66,
    "top-100": 11178.0,
  },

  beauty: {
    "completed-projects": 65,
    ROAS: 22.9,
    "click-growth": 81.0,
    "increase-views": 208.88,
    "top-100": 11279.0,
  },

  "uslugi-medyczne": {
    "completed-projects": 140,
    ROAS: 22.2,
    "click-growth": 82.1,
    "increase-views": 209.22,
    "top-100": 11377.22,
  },

  "branza-finansowa": {
    "completed-projects": 24,
    ROAS: 22.5,
    "click-growth": 82.5,
    "increase-views": 209.87,
    "top-100": 11245.0,
  },

  "uslugi-lokalne": {
    "completed-projects": 160,
    ROAS: 22.0,
    "click-growth": 80.4,
    "increase-views": 210.87,
    "top-100": 11233.54,
  },

  "dla-dzieci": {
    "completed-projects": 56,
    ROAS: 22.9,
    "click-growth": 81.7,
    "increase-views": 209.22,
    "top-100": 11543.22,
  },

  "branza-fashion": {
    "completed-projects": 75,
    ROAS: 23.3,
    "click-growth": 83.2,
    "increase-views": 209.76,
    "top-100": 11180.22,
  },
};

const experienceSection = document.querySelector("#experience");
let statsCategory;
let statsLine;

if (experienceSection) {
  statsCategory = experienceSection.querySelectorAll("[data-stats-category]");
  statsLine = experienceSection.querySelectorAll("[data-stats-line]");
}

let completedProjects, roas, clickGrowth, increaseViews, top100;

function initializeCountUp() {
  completedProjects = new CountUp("completedProjects", statsArray["statystyki-ogolne"]["completed-projects"], options);
  roas = new CountUp("roas", statsArray["statystyki-ogolne"]["ROAS"], options);
  clickGrowth = new CountUp("clickGrowth", statsArray["statystyki-ogolne"]["click-growth"], options);
  increaseViews = new CountUp("increaseViews", statsArray["statystyki-ogolne"]["increase-views"], options);
  top100 = new CountUp("top100", statsArray["statystyki-ogolne"]["top-100"], options);
}

function checkElementVisibility() {
  const element = document.getElementById("countBox");
  if (element && isElementInViewport(element)) {
    if (completedProjects.error) {
      // console.error(completedProjects.error);
    } else {
      completedProjects.start();
      roas.start();
      clickGrowth.start();
      increaseViews.start();
      top100.start();

      statsLine[0].setAttribute(
        "style",
        `background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
          statsArray["statystyki-ogolne"]["completed-projects"] / 2
        }%, rgba(38,39,41,1) ${statsArray["statystyki-ogolne"]["completed-projects"] / 2}%)`
      );
      statsLine[1].setAttribute(
        "style",
        `background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
          statsArray["statystyki-ogolne"]["increase-views"] / 2
        }%, rgba(38,39,41,1) ${statsArray["statystyki-ogolne"]["increase-views"] / 2}%)`
      );
      statsLine[2].setAttribute(
        "style",
        `background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
          statsArray["statystyki-ogolne"]["click-growth"] / 2
        }%, rgba(38,39,41,1) ${statsArray["statystyki-ogolne"]["click-growth"] / 2}%)`
      );
      statsLine[3].setAttribute(
        "style",
        `background .5s; background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
          statsArray["statystyki-ogolne"]["ROAS"] / 1
        }%, rgba(38,39,41,1) ${statsArray["statystyki-ogolne"]["ROAS"] / 1}%)`
      );
      statsLine[4].setAttribute(
        "style",
        `background .5s; background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) 80%, rgba(38,39,41,1) 80%)`
      );
    }

    window.removeEventListener("scroll", checkElementVisibility);
  }
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return rect.top < windowHeight && rect.bottom > 0 && rect.left < windowWidth && rect.right > 0;
}

statsCategory?.forEach((category) => {
  category.addEventListener("click", () => {
    statsCategory?.forEach((item) => item.classList.remove("active"));
    category.classList.add("active");

    const clickCategory = category.dataset.statsCategory;

    statsLine[0].setAttribute(
      "style",
      `background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
        statsArray[clickCategory]["completed-projects"] / 2
      }%, rgba(38,39,41,1) ${statsArray[clickCategory]["completed-projects"] / 2}%)`
    );
    statsLine[1].setAttribute(
      "style",
      `background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
        statsArray[clickCategory]["increase-views"] / 2
      }%, rgba(38,39,41,1) ${statsArray[clickCategory]["increase-views"] / 2}%)`
    );
    statsLine[2].setAttribute(
      "style",
      `background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
        statsArray[clickCategory]["click-growth"] / 2
      }%, rgba(38,39,41,1) ${statsArray[clickCategory]["click-growth"] / 2}%)`
    );
    statsLine[3].setAttribute(
      "style",
      `background .5s; background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) ${
        statsArray[clickCategory]["ROAS"] / 1
      }%, rgba(38,39,41,1) ${statsArray[clickCategory]["ROAS"] / 1}%)`
    );
    statsLine[4].setAttribute(
      "style",
      `background .5s; background: linear-gradient(90deg, rgba(15,16,18,1) 0%, rgba(239,84,48,1) 80%, rgba(38,39,41,1) 80%)`
    );

    completedProjects.update(statsArray[clickCategory]["completed-projects"]);
    increaseViews.update(statsArray[clickCategory]["increase-views"]);
    clickGrowth.update(statsArray[clickCategory]["click-growth"]);
    roas.update(statsArray[clickCategory]["ROAS"]);
    top100.update(statsArray[clickCategory]["top-100"]);
  });
});

initializeCountUp();

checkElementVisibility();
window.addEventListener("scroll", checkElementVisibility);
